import { useState, useEffect } from 'react';
import { IonModal, IonIcon, IonText } from '@ionic/react';
import { close } from 'ionicons/icons';
import { Accordion, AccordionSection } from 'react-rainbow-components';
import { Constants } from '../../../defines/Constants';
import { CleanHTML } from '../../../defines/Functions';
import axios from 'axios';
import Loading from '../../Loading';
import './RegisterTerms.css';

interface Props {
    tosId: any
}
const RegisterTerms = (props: Props) => {
    const [state, setState] = useState({
        showRegisterTermsModal: false,
        page: {} as any
    });
    const pageId = props.tosId;
    const pageApi = Constants.api.page;
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        const getPage = async () => {
            setLoading(true);
            try {
                const results = await axios.post(pageApi, { id: pageId }, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    }
                });
                if (results.status === 200) {
                    setState({ ...state, page: results.data.page_items[0] });
                    setLoading(false);
                }
            } catch (error: any) {
                console.log(error);
            }
        }
        if (state.showRegisterTermsModal) {
            getPage();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageApi, pageId, state.showRegisterTermsModal]);
    return (
        <>
            <IonModal isOpen={state.showRegisterTermsModal} onDidDismiss={() => setState({ ...state, showRegisterTermsModal: false })} mode="ios" cssClass="register-terms-modal">
                <div className="register-terms-modal-content">
                    <h3 className="register-terms-modal-title">
                        شرایط و قوانین
                        <IonIcon icon={close} onClick={() => setState({ ...state, showRegisterTermsModal: false })} />
                    </h3>
                    <div className="register-terms-modal-items">
                        {!loading ?
                            state.page !== undefined && Object.keys(state.page).length !== 0 &&
                            <>
                                <div className="content">
                                    <h6>{state.page.title}</h6>
                                    <IonText>
                                        {CleanHTML(state.page.text)}
                                    </IonText>
                                </div>
                                {(state.page.accordions !== undefined && state.page.accordions.length !== 0) &&
                                    <Accordion className="accordion">
                                        {state.page.accordions.map((accr: any, accrIndex: number) =>
                                            <AccordionSection label={accr.title} key={"index" + accrIndex}>
                                                <IonText>
                                                    {CleanHTML(accr.text)}
                                                </IonText>
                                            </AccordionSection>
                                        )}
                                    </Accordion>
                                }
                            </>
                            :
                            <Loading />
                        }
                    </div>
                </div>
            </IonModal>
            <span className="register-terms-link" onClick={() => setState({ ...state, showRegisterTermsModal: true })}>
                شرایط و قوانین
            </span>
        </>
    )
}
export default RegisterTerms;